/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { commonServices } from '../../../api/services/commonServices';
import { setUserProfilePic } from '../../../infra/aggregates/profilePicSlice';
import { useAppSelector, useAppDispatch } from '../../../infra/hooks';
import { userService } from '../../../api/services/userService';
import { setEmployeeCompanyData } from '../../../infra/aggregates/employeeCompanySlice';

interface headerType {
  profile_pic: any;
  name: string;
  designation: string;
  company_logo: string;
}

interface PropsValues {
  setHeaderData: (data: headerType) => void;
}

function DTOHeader({ setHeaderData }: PropsValues) {
  const selector = useAppSelector((state) => state);

  const [profilePic, setProfilePic] = useState('');
  const companyId = useAppSelector((state) => state.authSlice?.company_id);

  const dispatch = useAppDispatch();
  let initializeData: headerType = {
    name: '',
    profile_pic: '',
    designation: '',
    company_logo: '',
  };

  async function getProfilePic(userId: number) {
    const getProfilePic: any =
      await commonServices.getFullPathProfilePic(userId);
    if (getProfilePic?.response == 'success') {
      setProfilePic(getProfilePic?.data?.profile_pic);
      dispatch(setUserProfilePic(getProfilePic?.data?.profile_pic));
    }
  }

  async function getCompanyLogo() {
    await userService
      .getCompanDetail(companyId)
      .then((response: any) => {
        if (response.response == 'success') {
          dispatch(setEmployeeCompanyData({ logo: response?.data?.logo }));
        }
      })
      .catch((err) =>
        console.log('error while getting company detail for employee', err),
      );
  }

  useEffect(() => {
    initializeData = {
      name:
        selector.personalInfoSlice.firstName +
        ' ' +
        selector.personalInfoSlice.lastName,
      profile_pic: selector?.profilePicSlice?.profilePic,
      designation: selector?.authSlice?.designaion,
      company_logo: selector?.employeeCompanySlice.logo,
    };
    setHeaderData(initializeData);
  }, [
    selector.personalInfoSlice.firstName,
    selector.authSlice,
    selector?.employeeCompanySlice.logo,
    selector?.profilePicSlice?.profilePic,
  ]);

  useEffect(() => {
    initializeData = {
      name:
        selector.personalInfoSlice.firstName +
        ' ' +
        selector.personalInfoSlice.lastName,
      profile_pic: selector?.profilePicSlice?.profilePic,
      designation: selector?.authSlice?.designaion,
      company_logo: selector?.employeeCompanySlice.logo,
    };
    setHeaderData(initializeData);
  }, [selector?.profilePicSlice?.profilePic]);

  useEffect(() => {
    getProfilePic(selector.authSlice.user_id);
    getCompanyLogo();
    initializeData = {
      name: selector?.personalInfoSlice?.firstName
        ? selector.personalInfoSlice.firstName +
        ' ' +
        selector.personalInfoSlice.lastName
        : selector?.authSlice?.name,
      profile_pic: profilePic || selector?.profilePicSlice?.profilePic,
      designation: selector?.authSlice?.designaion,
      company_logo: selector?.employeeCompanySlice.logo,
    };
    setHeaderData(initializeData);
  }, []);
  return <></>;
}
export default DTOHeader;
